import { Location } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart , Router  } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/services/auth.service';
import { CommunicationService } from 'src/services/communication.service';
import { LoaderService } from '../core/loader/loader.service';
import { RestService } from '../core/rest.service';
import { HttpClient } from '@angular/common/http';

declare let ga: any;
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
  
})
export class AppComponent implements OnInit {
  public defaultLanguage: string;
  public supportedLanguages: any;
  public showFooter = true;
  iadvlConst;
  public loaderService: LoaderService;
  constructor(private location: Location ,
              public cookieService: CookieService,
              private router: Router, loaderService: LoaderService, public restService: RestService,
              public communicationService: CommunicationService, public authService:AuthService,private http: HttpClient) {
      this.loaderService = loaderService;
      this.router.events.subscribe((event) => {
        if ((event) instanceof RouteConfigLoadStart) {
          this.loaderService.show();
        } else if ((event) instanceof RouteConfigLoadEnd) {
          this.loaderService.hide();
        }
        // if (event instanceof NavigationEnd) {
        //   ga('set', 'page', event.urlAfterRedirects);
        //   ga('send', 'pageview');
        // }
    });
      this.restService.forceLogout.subscribe((value) => {
      if (value === true) {
        this.cleanAndLogout();
      }
    });
      this.defaultLanguage = 'en-US';
      this.supportedLanguages = ['en-US', 'zh-Hant' ];
    
  }

  public ngOnInit() {
    if (this.location.path().startsWith('/ckeditorLineComment')) {
      this.showFooter = false;
    }
    const iadvlConst = localStorage.getItem('iadvlConst');
    if(iadvlConst){
      this.iadvlConst = JSON.parse(iadvlConst);
    } else {
      this.getConsts();
    }
  }

  public getConsts() {
    var val = Math.floor(1000 + Math.random() * 9000);
    this.http.get(`../assets/const.json?rand=${val}`).subscribe(res => {
      if(res){
        this.iadvlConst = res;
        localStorage.setItem('iadvlConst',JSON.stringify(res));
      }
    });
  }
  
  public cleanAndLogout() {
    this.cookieService.deleteAll();
    sessionStorage.clear();
    localStorage.clear();
    this.communicationService.onlogoutUser();
    if (this.router.url !== '/iadvl') {
      this.cookieService.set('lastUrl', this.router.url);
    }
    this.router.navigate(['/iadvl']);
   }
}
